import { useEffect, useState } from "react";
import { Switch, Button, FormControlLabel } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import useAuth from "../../../hooks/useAuth";
import { apiVariable } from "../../../api/apiVariable";

const AddInMcleodButton = ({
  id,
  moneyRequest,
}: {
  id: string;
  moneyRequest: any;
}) => {
  const [isEnabled, setIsEnabled] = useState(false);
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const queryClient = useQueryClient();
  const { token } = useAuth();

  useEffect(() => {
    setIsEnabled(moneyRequest.isAddedInMcleod || false);
  }, [moneyRequest]);

  const addInMcleodMutation = useMutation({
    mutationFn: () =>
      axios
        .put(`${apiVariable}/addInMcleod/${id}`, isEnabled, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((response) => response.data),
    onSuccess: () => {
      setStatus("success");
      queryClient.invalidateQueries({ queryKey: ["moneyRequests"] });
      queryClient.invalidateQueries({ queryKey: ["needingApprovalRequests"] });
      queryClient.invalidateQueries({ queryKey: ["allRequests"] });
    },
    onError: (error: any) => {
      setStatus("error");
      setErrorMessage(error.response.data || "Failed to update McLeod");
    },
  });

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsEnabled(event.target.checked);
    if (event.target.checked) {
      addInMcleodMutation.mutate();
    } else {
      setIsEnabled(false);
      addInMcleodMutation.mutate();
    }
  };

  return (
    <div>
      <FormControlLabel
        control={<Switch checked={isEnabled} onChange={handleSwitchChange} />}
        label=""
      />
      {status === "error" && <p style={{ color: "red" }}>{errorMessage}</p>}
    </div>
  );
};

export default AddInMcleodButton;
